<template>
  <div class="dd-grid">
    <label
      >製品Version・Build（必須）<input
        v-model="form.docker_version"
        required
        placeholder="Ver.1.1.2_20261103_1"
    /></label>
    <label
      >リリース日（必須）<input
        v-model="form.release_date"
        type="date"
        required
    /></label>
    <label
      >対象構成<select v-model="form.configuration">
        <option>SA</option>
        <option>CS</option>
      </select></label
    >
    <label
      >初回・更新<select v-model="form.install_kind">
        <option value="IN">初回導入 IN</option>
        <option value="UP">更新 UP</option>
      </select></label
    >
    <label
      >対応区分<select v-model="form.change_type">
        <option value="">未分類（旧登録）</option>
        <option value="BG">BG 障害対応</option>
        <option value="MD">MD 機能改修</option>
        <option value="EN">EN 機能追加</option>
        <option value="CI">CI 機能連携変更</option>
      </select></label
    >
    <label
      >対象OS<select v-model="form.target_os">
        <option value="windows">Windows</option>
        <option value="linux">Linux</option>
        <option value="macos">macOS</option>
      </select></label
    >
    <label
      >アーキテクチャ<select v-model="form.target_arch">
        <option>x64</option>
        <option>arm64</option>
      </select></label
    >
    <label v-if="form.install_kind === 'UP'"
      >更新元の製品Version・Build（必須）<input
        v-model="form.from_release"
        required
        placeholder="1.1.2_20261029_2"
    /></label>
    <label
      >対象Block<input
        v-model="form.module_ids"
        placeholder="例：F14,F16（全体配布は空欄）"
    /></label>
    <label class="wide"
      >バージョン説明（必須）<input
        v-model="form.docker_info"
        maxlength="200"
        required
    /></label>
    <label class="wide"
      >リリースノート<textarea
        v-model="form.release_notes"
        rows="4"
        maxlength="50000"
      />
    </label>
  </div>
</template>
<script>
export default {
  name: 'InstallerFields',
  props: { form: { type: Object, required: true } },
};
</script>
